module.exports = __webpack_public_path__ + "img/mobile-university-logo.2bbd0e39.jpg";